import Wallet from "../pages/commanPage/wallet/Wallet";
import WalletAddBank from "../pages/commanPage/wallet/children/WalletAddBank";
import Walletbankdetails from "../pages/commanPage/wallet/children/Walletbankdetails";
import WalletUpdateBank from "../pages/commanPage/wallet/children/WalletUpdateBank";
import WalletAccount from "../pages/commanPage/wallet/components/WalletAccount";
import SuccessfullyPages from "../pages/commanPage/wallet/components/PaymentSucessPage";
import PageNotFound from "../pages/commanPage/errorPage/PageNotFound";
import ProfileDetails from "../pages/commanPage/profile/ProfileDetails";
import MoneyTransfer from "../pages/commanPage/wallet/components/MoneyTransfer";
import AddMoneyToWallet from "../pages/commanPage/wallet/components/AddMoneyToWallet";
import AllNotificationComponent from "../pages/commanPage/notification/components/AllNotificationComponent";
import CatalogueViewPdf from "../pages/buyerAuction/buyer/AuctionDetail/catelogue/CatalogueViewPdf";
import Pickup from "../pages/commanPage/pickup/Pickup";
import PaymentIndtruction from "../pages/commanPage/wallet/children/PaymentIndtruction";

export const sharedRoutes = [
  {
    path: "wallet",
    element: <Wallet />,
  },
  {
    path: "wallet/add-bank",
    element: <WalletAddBank />,
  },
  {
    path: "wallet/bank-details",
    element: <Walletbankdetails />,
  },

  {
    path: "wallet/update-bank",
    element: <WalletUpdateBank />,
  },
  {
    path: "wallet/wallet-account",
    element: <WalletAccount />,
  },

  {
    path: "wallet/add-money",
    element: <AddMoneyToWallet />,
  },
  {
    path: "/payment/help-instruction",
    element: <PaymentIndtruction />,
  },
  {
    path: "wallet/addMoney-details",
    element: <MoneyTransfer />,
  },

  {
    path: "successful-add-money",
    element: <SuccessfullyPages />,
  },
  // {
  //   path: "helpline",
  //   element: <HelpLinePage />,
  // },
  {
    path: "notification",
    element: <AllNotificationComponent />,
  },
  {
    path: "profile",
    element: <ProfileDetails />,
  },
  {
    path: "pickup",
    element: <Pickup />,
  },
  {
    path: "catalogue-view/:id",
    element: <CatalogueViewPdf />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
